import { FC, useEffect } from 'react'
import { stylesheet, classes } from 'typestyle'

/* Hooks ======================================================================================== */
import useValue from '../../__aeki__/hooks/use-value'
import useFetch from '../../__aeki__/hooks/use-fetch'
import useBoolean from '../../__aeki__/hooks/use-boolean'

/* Common ======================================================================================= */
import { get } from '../../__aeki__/share/find'
import { getCurrentUser } from '../../__aeki__/services/auth'

/* Components =================================================================================== */
import AppLayout, { MAX_WIDTH } from './layout'
import Footer from '../__home__/components/footer'
import Skeleton from '../../__aeki__/components/skeleton'
import { Box } from '../../__aeki__/components/box/box.component'
import { ButtonRaw } from '../../__aeki__/components/button'
import { Form } from '../../__aeki__/components/form'
import { Line } from '../../__aeki__/components/line'
import { Loader } from '../../__aeki__/components/loader'
import { Text } from '../../__aeki__/components/text/text.component'
import { Title } from '../../__aeki__/components/text/title.component'
import { VisibleOpacity } from '../__home__/components/visible/visible-opacity'
import { renderForm } from '../../__aeki__/modules/handlers/render-form'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../__aeki__/components/style-class/style-class.utils'
import { mb12 } from '../../__aeki__/styles/styleset/margin/mb12'
import { mb4 } from '../../__aeki__/styles/styleset/margin/mb4'
import { mb48 } from '../../__aeki__/styles/styleset/margin/mb48'
import { mb8mdi } from '../../__aeki__/styles/styleset/margin/mb8mdi'
import { mt80 } from '../../__aeki__/styles/styleset/margin/mt80'
import { pb32 } from '../../__aeki__/styles/styleset/padding/pb32'
import { pl0mdi } from '../../__aeki__/styles/styleset/padding/pl0mdi'
import { pr0mdi } from '../../__aeki__/styles/styleset/padding/pr0mdi'
import { rowmdi } from '../../__aeki__/styles/styleset/row/rowmdi'
import { w100mdi } from '../../__aeki__/styles/styleset/width/w100mdi'
import { pt40 } from '../../__aeki__/styles/styleset/padding/pt40'
import { paddingVerticalOuter } from '../../__aeki__/styles/default/padding'
import { rowsmi } from '../../__aeki__/styles/styleset/row/rowsmi'
import { textCenter } from '../../__aeki__/styles/styleset/text-center/textCenter'
import { mt8 } from '../../__aeki__/styles/styleset/margin/mt8'

/* <ContactUs /> ================================================================================ */
const ContactUs: FC<any> = (props: any) => {
  const { inject, eject } = props
  const injection = inject()

  const cleanFields = (payload: any) => {
    const fields = get('base.form.fields', payload, 'array')

    if (fields.length > 0) {
      const { currentUser } = getCurrentUser()

      if (currentUser && currentUser.email) {
        fields[1].disabled = true
      }
    }

    return fields
  }

  const [values, $values] = useValue({
    email: getCurrentUser().currentUser ? getCurrentUser().currentUser.email : '',
  })
  const [fields, $fields] = useValue(
    Object.keys(injection).length > 0 ? cleanFields(injection) : [],
  )

  const [isSubmitted, $isSubmiited] = useBoolean(false)

  const [meta, $meta] = useFetch(
    Object.keys(injection).length
      ? injection
      : {
          base: {
            sections: [],
          },
        },
    {
      url: `${process.env.REACT_APP_API_URL}/a/contact-us`,
    },
  )

  const [a, $a] = useFetch(
    {
      body: {
        body: [],
      },
    },
    {
      url: `${process.env.REACT_APP_API_URL}/a/contact-us`,
    },
  )

  useEffect(() => {
    if (meta.mounted) {
      $meta.get().then((payload: any) => {
        if (Object.keys(injection).length === 0) {
          $fields.set(cleanFields(payload))

          $values.set((prev: any) => ({ ...prev, ticketType: payload.base.form.fields[0].value }))
        }
      })
    }
  }, [meta.mounted])

  useEffect(() => {
    return () => {
      eject()
    }
  }, [])

  return (
    <AppLayout.render
      head={{
        title: `Contact us - ${process.env.REACT_APP_PROJECT_NAME}`,
        description: 'Contact us',
        mainImage: process.env.REACT_APP_PROJECT_MAIN_IMAGE,
      }}
      headerProps={{
        maxWidth: MAX_WIDTH,
        scrollEffect: true,
        allowToggleEffect: true,
      }}
      content={
        <>
          <Box baseline="secondary" className={STYLES.containerHero} row>
            <Box
              baseline="none"
              className={STYLES.containerHeroContent}
              flex
              alignCenterX
              alignCenterY
            >
              <Box
                className={classes(paddingVerticalOuter)}
                baseline="none"
                maxWidth={MAX_WIDTH}
                centerAutoX
                fullWidth
                row
              >
                <VisibleOpacity>
                  <Box className={classes(textCenter, rowsmi)} row baseline="none" alignCenterX>
                    <Title className={textCenter} size="md" semiBold tag={'h1'} crank>
                      Contact us
                    </Title>
                    <Text baseline="primary" className={mt8} size="lg" tag={'h2'}>
                      by filling out the form below
                    </Text>
                  </Box>
                </VisibleOpacity>
              </Box>
            </Box>
          </Box>
          <Box className={classes(pb32)}>
            <Box
              className={classes(paddingVerticalOuter)}
              baseline="none"
              maxWidth={MAX_WIDTH}
              centerAutoX
              fullWidth
            >
              <Box className={classes(mt80, mb48, rowmdi, mb8mdi)} baseline="none">
                <Box
                  className={classes(w100mdi, pl0mdi, pr0mdi)}
                  baseline="surface"
                  alignCenterX
                  alignCenterY
                  flex
                >
                  <Form
                    key={0}
                    values={values}
                    onSubmit={(data: any) => {
                      $isSubmiited.set(true)

                      $fields.set((prev: any) => {
                        return prev.map((field: any) => {
                          return {
                            ...field,
                            disabled: true,
                          }
                        })
                      })

                      if (!a.meta.isLoading) {
                        $a.post({ body: data })
                        $values.set(data)
                      }
                    }}
                  >
                    <Box maxWidth={440} fullWidth>
                      <Loader
                        loaded={!!fields.length}
                        skeleton={
                          <Box row flex>
                            <Skeleton width="40%" height={14} className={mb4} />
                            <Skeleton width="100%" height={42} className={mb12} />
                            <Skeleton width="40%" height={14} className={mb4} />
                            <Skeleton width="100%" height={42} className={mb12} />
                            <Skeleton width="40%" height={14} className={mb4} />
                            <Skeleton width="100%" height={80} className={mb12} />
                            <Skeleton width="100%" height={42} />
                          </Box>
                        }
                        component={
                          <>
                            {fields.map((field: any) => {
                              return renderForm({
                                field: {
                                  ...field,
                                  // disabled: true,
                                },
                                parentName: '',
                                values,
                                entryUrl: `${process.env.REACT_APP_API_URL}/app`,
                              })
                            })}
                            {/* <ReCAPTCHA sitekey="Your client site key" onChange={onChange} /> */}
                            <Box flex alignRight fullWidth>
                              {isSubmitted ? (
                                <ButtonRaw
                                  baseline={'disabled'}
                                  label="Submitted!"
                                  size="md"
                                  square
                                  alt
                                  disabled={true}
                                />
                              ) : (
                                <ButtonRaw
                                  baseline={'primary'}
                                  label="Submit"
                                  size="md"
                                  square
                                  type="submit"
                                />
                              )}
                            </Box>
                          </>
                        }
                      />
                    </Box>
                  </Form>
                </Box>
              </Box>
            </Box>
          </Box>
          <Line />
          <Box className={classes(pt40)} baseline="background">
            <Footer />
          </Box>
        </>
      }
    />
  )
}

/* Styles ======================================================================================= */
const STYLES = stylesheet({
  containerHero: {
    marginTop: -56,
    paddingTop: 56,
  },
  containerHeroContent: {
    minHeight: 580,
    paddingTop: 162,
    paddingBottom: 160,
    ...createMediaQuery.sm({
      minHeight: 'calc(100vh - 53px)',
    }),
  },
  lineHero: {
    opacity: 0.1,
  },
})

export default ContactUs
